import { Navigate, Outlet } from 'react-router-dom';

type TPrivateRoute = {
  redirect: string;
  allowed: boolean;
};
const PrivateRoute = ({ redirect, allowed }: TPrivateRoute) => {
  return allowed ? <Outlet /> : <Navigate to={redirect} />;
};

export default PrivateRoute;
